// extracted by mini-css-extract-plugin
module.exports = {"container":"InstitutionItem_container__2yzTG","item":"InstitutionItem_item__1EIR2","link":"InstitutionItem_link__1RLCh"};